import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


import { ServiceBase } from '@app/services/base.service';
import { ProcessoDocumentoPendente } from '@app/models/processo-documento-pendente.model';

@Injectable()
export class ProcessoDocumentoService extends ServiceBase {
  constructor(
    private http: HttpClient,
  ) {
    super();
  }
  // adicionar(atoProcessual: ProcessoDocumento) {
  //   return this.http.post(this.URL_API + "ProcessoDocumento", atoProcessual, this.obterAutorizacao())
  //     .catch((error: any) => Observable.throw(error.json()));
  // }

  // alterar(atoProcessual: ProcessoDocumento) {
  //   return this.http.put(this.URL_API + "ProcessoDocumento", atoProcessual, this.obterAutorizacao())
  //     .catch((error: any) => Observable.throw(error.json()));
  // }

  // deletar(id: number) {
  //   return this.http.delete(this.URL_API + `ProcessoDocumento/${id}`, this.obterAutorizacao());
  // }

  // obterPorId(id: number) {
  //   return this.http.get(this.URL_API + `ProcessoDocumento/${id}`, this.obterAutorizacao())
  //     .map((res: Response) => <ProcessoDocumento>(res.json()));
  // }
  
  // obterPorProcesso(id: number) {
  //   return this.http.get(this.URL_API + `ProcessoDocumento/ObterPorProcesso/${id}`, this.obterAutorizacao())
  //     .map((res: Response) => <ProcessoDocumento[]>(res.json()));
  // }
  // obterTodos() {
  //   return this.http.get(this.URL_API + `ProcessoDocumento`, this.obterAutorizacao())
  //     .map((res: Response) => res.json());
  // }
}